import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import en from "./locales/en.json";
import fr from "./locales/fr.json";
import es from "./locales/es.json";
import it from "./locales/it.json";
import el from "./locales/el.json";
import ru from "./locales/ru.json";
import sr from "./locales/sr.json";
import de from "./locales/de.json";
import zh from "./locales/zh.json";

const savedLang = localStorage.getItem("seaventis-lang") || "en";

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    fr: { translation: fr },
    es: { translation: es },
    it: { translation: it },
    el: { translation: el },
    ru: { translation: ru },
    sr: { translation: sr },
    de: { translation: de },
    zh: { translation: zh },
  },
  lng: savedLang,
  fallbackLng: "en",
  interpolation: { escapeValue: false },
});

export const languages = [
  { code: "en", label: "English", flag: "🇬🇧" },
  { code: "fr", label: "Français", flag: "🇫🇷" },
  { code: "es", label: "Español", flag: "🇪🇸" },
  { code: "it", label: "Italiano", flag: "🇮🇹" },
  { code: "el", label: "Ελληνικά", flag: "🇬🇷" },
  { code: "ru", label: "Русский", flag: "🇷🇺" },
  { code: "sr", label: "Srpski", flag: "🇷🇸" },
  { code: "de", label: "Deutsch", flag: "🇩🇪" },
  { code: "zh", label: "中文", flag: "🇨🇳" },
];

export default i18n;
